<template>
  <b-card no-body class="border mb-2">
    <b-card-body class="pb-0">
      <h5 class="mb-0">Failures</h5>
      <small class="text-muted">
        Grouped by endpoint and reason — the first place to look when a partner reports a problem
      </small>
    </b-card-body>

    <b-table
      :items="errors"
      :fields="fields"
      responsive
      show-empty
      empty-text="No failures in this window."
      class="mb-0 usage-errors-table"
    >
      <template #cell(route)="data">
        <b-badge pill :variant="`light-${methodVariant(data.item.method)}`" class="mr-50">
          {{ data.item.method }}
        </b-badge>
        <code class="text-body">{{ data.item.route }}</code>
      </template>

      <template #cell(status_code)="data">
        <b-badge pill :variant="`light-${statusVariant(data.item.status_code)}`">
          {{ data.item.status_code }}
        </b-badge>
        <div class="small text-muted text-capitalize">{{ outcomeLabel(data.item.outcome) }}</div>
      </template>

      <template #cell(message)="data">
        <span class="text-body">{{ data.item.message || '—' }}</span>
      </template>

      <template #cell(count)="data">
        {{ formatCount(data.item.count) }}
      </template>

      <template #cell(last_seen)="data">
        {{ formatTimestamp(data.item.last_seen) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable, BBadge } from 'bootstrap-vue'
import {
  formatCount,
  methodVariant,
  outcomeLabel,
  statusVariant,
} from './usageFormat'

/**
 * Grouped failures.
 *
 * Reads individual request rows rather than rollups, because the message text only
 * exists there — which is also why failed rows are kept for six weeks while routine
 * successes roll off in two.
 */
export default {
  name: 'UsageErrorsTable',
  components: {
    BCard,
    BCardBody,
    BTable,
    BBadge,
  },
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: 'route', label: 'Endpoint' },
        { key: 'status_code', label: 'Status' },
        { key: 'message', label: 'Reason' },
        { key: 'count', label: 'Count', class: 'text-right' },
        { key: 'last_seen', label: 'Last seen', class: 'text-right' },
      ],
    }
  },
  methods: {
    formatCount,
    outcomeLabel,
    statusVariant,
    methodVariant,
    formatTimestamp(value) {
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString()
    },
  },
}
</script>

<style scoped>
.usage-errors-table >>> td,
.usage-errors-table >>> th {
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
}
</style>
